module.exports = __webpack_public_path__ + "assets/img/right_check.png?faa7d4fc60f3dbdc7a1cd262e1b47f4c";